export const AdmissionsActions = {
  GET_ADMISSIONS: "GET_ADMISSIONS",
  SET_ADMISSIONS: "SET_ADMISSIONS",

  GET_ADMISSIONS_DETAIL: "GET_ADMISSIONS_DETAIL",
  SET_ADMISSIONS_DETAIL: "SET_ADMISSIONS_DETAIL",

};
